import React from 'react';
import './AccountGroupHeader.scss';

interface AccountGroupHeaderProps {
  email: string;
  accountId: number;
  projectCount: number;
  isCollapsed: boolean;
  onToggleCollapse: () => void;
}

const AccountGroupHeader: React.FC<AccountGroupHeaderProps> = ({
  email,
  accountId,
  projectCount,
  isCollapsed,
  onToggleCollapse,
}) => {
  return (
    <div
      className={`account-group-header${isCollapsed ? ' account-group-header--collapsed' : ''}`}
      onClick={onToggleCollapse}
    >
      <div className="account-group-header__left">
        <span className="ico--up ico--xs account-group-header__chevron" />
        <span className="account-group-header__email">{email}</span>
        <span className="account-group-header__id">#{accountId}</span>
        <span className="account-group-header__count">{projectCount}</span>
      </div>
    </div>
  );
};

export default AccountGroupHeader;
